import { render, staticRenderFns } from "./EventFaq.vue?vue&type=template&id=46cdd045&scoped=true&"
import script from "./EventFaq.vue?vue&type=script&lang=js&"
export * from "./EventFaq.vue?vue&type=script&lang=js&"
import style0 from "./EventFaq.vue?vue&type=style&index=0&id=46cdd045&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cdd045",
  null
  
)

export default component.exports